import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${({ theme }) => theme.colors.gulfStream};
  font-size: 14px;
  ${({ theme }) => theme.fonts.regular};
  padding: 0;
  margin-bottom: 16px;

  &:hover {
    opacity: 0.75;
  }
`;

export const FormContainer = styled.form`
  padding: 16px 0;
  display: grid;
`;

export const InputSelectContainer = styled.div`
  color: ${({ theme }) => theme.colors.matterhorn};
  ${({ theme }) => theme.fonts.regular};
  font-size: 13px;
`;

export const ImageUploadSection = styled.div`
  border: 1px dashed ${({ theme }) => theme.colors.lightGray};
  border-radius: 8px;
  padding: 16px;
`;

export const SectionLabel = styled.span`
  display: block;
  font-size: 13px;
  ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.matterhorn};
  margin-bottom: 12px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  max-height: 220px;
  object-fit: contain;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.concrete};
  display: block;
  margin-bottom: 12px;
`;

export const ExtraImageList = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const ExtraImageThumb = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
`;

export const ExtraImageImg = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
`;

export const RemoveImageBtn = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  background: ${({ theme }) => theme.colors.errorRed};
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  font-size: 12px;
  line-height: 1;
  padding: 0;
`;

export const UploadLabel = styled.label<{ $disabled?: boolean }>`
  display: inline-block;
  background: ${({ theme }) => theme.colors.gulfStream};
  color: ${({ theme }) => theme.colors.white};
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  ${({ theme }) => theme.fonts.regular};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  input[type='file'] {
    display: none;
  }
`;
